import React, { InputHTMLAttributes, ReactNode, useMemo } from 'react'

import { OptionType } from '~/shared/constants'

import { StyledOption as S } from './Option.styles'

export type TProps = {
  type?: OptionType
  value: string
  name?: string
  checked?: boolean
  fullWidth?: boolean
  marginBottom?: string
  className?: string
  disabled?: boolean
  onChange?: (value: string, isChecked: boolean) => void
  children: ReactNode
}

export const Option: React.FC<TProps> = ({
  type,
  value,
  children,
  name,
  checked,
  disabled,
  className,
  marginBottom = '16',
  onChange,
  ...rest
}) => {
  const inputProps = useMemo((): InputHTMLAttributes<HTMLInputElement> => {
    const props: InputHTMLAttributes<HTMLInputElement> = {
      value,
      type,
      onChange: ({ target }: React.ChangeEvent<HTMLInputElement>) =>
        onChange && onChange(target.value, target.checked),
    }

    if (name) {
      props.name = name
    }

    if (checked !== undefined) {
      props.checked = checked
    }

    return props
  }, [checked, name, onChange, type, value])

  return (
    <S.OptionContainer
      data-testid="option"
      marginBottom={marginBottom}
      className={className}
      {...rest}
    >
      <input data-testid="option-input" disabled={disabled} {...inputProps} />
      {children}
    </S.OptionContainer>
  )
}
